import { render, staticRenderFns } from "./ReporteCuentas.vue?vue&type=template&id=cea1950a&scoped=true&"
import script from "./ReporteCuentas.vue?vue&type=script&lang=js&"
export * from "./ReporteCuentas.vue?vue&type=script&lang=js&"
import style0 from "./ReporteCuentas.vue?vue&type=style&index=0&id=cea1950a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea1950a",
  null
  
)

export default component.exports